export default function(response) {
    const {rateA = 0, rateB = 0, prevRateB = 0, prevRateA = 0} = response;

    return {
        ccyB: response.curB,
        ccyA: response.curA,
        rateB: response.rate_buy,
        rateC: response.rate_sell,
        prevRateB,
        prevRateA,
        id: response.curA + '-' + response.curB,
        date: 'now'
    };
}
